module.exports = __webpack_public_path__ + "static/media/radio_checked.2cb4b346.svg";